module.exports = __webpack_public_path__ + "img/40_38_072_770.b5889ef2.jpg";